// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOmnibusTypePropertyDto
 */
export interface IOmnibusTypePropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IOmnibusTypePropertyDto
     */
    omnibus_type?: IOmnibusTypePropertyDtoOmnibusTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IOmnibusTypePropertyDto
     */
    omnibus_type_state?: IOmnibusTypePropertyDtoOmnibusTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IOmnibusTypePropertyDtoOmnibusTypeEnum {
    HSA = 'HSA',
    NOTIONAL = 'NOTIONAL'
}
/**
* @export
* @enum {string}
*/
export enum IOmnibusTypePropertyDtoOmnibusTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IOmnibusTypePropertyDto interface.
 */
export function instanceOfIOmnibusTypePropertyDto(value: object): value is IOmnibusTypePropertyDto {
    return true;
}

export function IOmnibusTypePropertyDtoFromJSON(json: any): IOmnibusTypePropertyDto {
    return IOmnibusTypePropertyDtoFromJSONTyped(json, false);
}

export function IOmnibusTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOmnibusTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'omnibus_type': json['omnibus_type'] == null ? undefined : json['omnibus_type'],
        'omnibus_type_state': json['omnibus_type_state'] == null ? undefined : json['omnibus_type_state'],
    };
}

export function IOmnibusTypePropertyDtoToJSON(json: any): IOmnibusTypePropertyDto {
    return IOmnibusTypePropertyDtoToJSONTyped(json, false);
}

export function IOmnibusTypePropertyDtoToJSONTyped(value?: IOmnibusTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'omnibus_type': value['omnibus_type'],
        'omnibus_type_state': value['omnibus_type_state'],
    };
}

